import { SimpleCenterLayout } from "@mnk/frontend/components/layouts/SimpleCenterLayout";
import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <SimpleCenterLayout>
      <h2 className="text-xl font-bold text-center">エラー</h2>

      <p className="text-sm my-4 text-gray-500 text-center">ページが見つかりませんでした。</p>

      <PrimaryButton className="w-full" onClick={() => navigate("/")}>
        トップへ戻る
      </PrimaryButton>
    </SimpleCenterLayout>
  );
};
